export enum WebCaches {
  EnableSingleLogon = 'dataCacheSelectEnableSingleLogon',
  LocalizationLng = 'dataCacheLocalization',
  EsoFirstObject = 'dataCacheEsoFirstObject'
}

export enum LogoutWebCaches {
  EnableSingleLogon = 'dataCacheSelectEnableSingleLogon',
  LocalizationLng = 'dataCacheLocalization',
  EsoFirstObject = 'dataCacheEsoFirstObject'
}